/**
 * Angular imports.
 */
import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';

/**
 * Service imports.
 */
import { GetService } from '../../../dataservices/get.service';
import { PostApiService } from '../../../dataservices/post-api.service';
import { FunCollectionService } from '../../../common/common-functions/fun-collection.service';
import { DataStorageService } from '../../../dataservices/data-storage.service';
import { FileUploadService } from '../../../dataservices/file-upload.service';
import { MultiLangService } from '../../../dataservices/master-service/multi-lang.service';
import { JwtDecodeService } from '../../../dataservices/jwt-decode.service';
import { NewLanguageService } from '../../../dataservices/new-language/new-language.service';

/**
 * Rxjs imports.
 */
import { Subscription } from 'rxjs';
 import { SCREEN_NAME, COMMUNITY_LIST_TYPE, PRODUCT_TYPE_CONSTANT, NUMBERS, STATUS_CODE, REPOST_STATUS, MAPPED_PRODUCT_IN_COMMUNITY } from '../../../constants/app.constants';


@Component({
  selector: 'app-post-community',
  templateUrl: './post-community.component.html',
  styleUrls: ['./post-community.component.scss']
})
export class PostCommunityComponent implements OnInit, OnDestroy {

  /**
   * Event Emitter to Pass Selected Commuinty Based flag to Post Association Component
   * to Check either need to enable post button or not
   */
  @Output() checkSelectedCommunityList = new EventEmitter();
  /**
   * Store the User Community List
  */
  public user_community_list = [];
  /**
   * To Show the Validation Message if Selected Community more then 5
  */
  public err_msg = '';
  /**
   * Flag to mention that either Post button should be enable or disabled
  */
  public showColor = false;
  /**
   * Flag to set Loader while api calling
  */
  public loading_data_in_process = false;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Analytics session time.
   */
  private sessiontime = { 'start_time': '', 'end_time': '' };
  /**
   * Flag to Check if Need to show View More 2 (Community) button
   */
  public view_more_community_flag = false;
  /**
   * Flag to Check current offset for Community
   */
  public viewMoreOffset = NUMBERS.ONE;
  /**
   * View 10 More
   */
  public tenMore = NUMBERS.TEN;
  /**
   * Flag to Check length of community list
   */
  @Output() listLength: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * Necessary instances
   */
  constructor(
    private getSer: GetService,
    private postSer: PostApiService,
    public fcs: FunCollectionService,
    public dss: DataStorageService,
    private fileus: FileUploadService,
    public multiLangService: MultiLangService,
    public jwtSer: JwtDecodeService,
    public mls: NewLanguageService
  ) { }

  ngOnInit(): void {

    if(MAPPED_PRODUCT_IN_COMMUNITY.indexOf(this.dss.repostProductType) !== -1 ) {
      this.getUserCommunity();
    }
  }

  /**
   * get User Community
  */
  getUserCommunity(): void {
    /**
      * Show Community which is are selected during post,should be come up on top , pass these parameters in api call
    */
    let additionalParam = {};
    let repostParam = {};
    if (this.dss.posting_data.feed_edit_mode.feed_id && !this.dss.isRepostStatus) {
      additionalParam = {
        product_type: PRODUCT_TYPE_CONSTANT.FEED,
        product_id: this.dss.posting_data.feed_edit_mode.feed_id
      };
    } else if (this.dss.isRepostStatus === REPOST_STATUS.TWO) {
      repostParam = {
        repost_product_id: this.dss.repostProductId,
        repost_product_type: this.dss.repostProductType
      };
    }
    this.loading_data_in_process = false;
    this.subscriptions.add(this.getSer.getCommunityList(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY, this.viewMoreOffset.toString(), additionalParam, repostParam).subscribe(resData => {
      this.loading_data_in_process = false;
      this.viewMoreOffset = resData.data.offset;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == NUMBERS.ONE) {
          if (data.code == STATUS_CODE.TWO_THOUSAND) {
            this.dss.user_community_list = resData.data.community_list[0]['list'];
            this.view_more_community_flag = resData.data.community_list[0]['flags']['view_more'];
            if (this.dss.user_community_list.length) {
              this.listLength.emit(true);
            }
            if (this.dss.calling_from_community) {
              const commDetail = this.dss.calling_from_community_object;
              commDetail['checked'] = true;
              this.dss.user_community_list.unshift(commDetail);
            }
            this.dss.user_community_list.map((commData, index) => {
              if (commData?.id === this.dss.calling_from_community_object['id'] && index && this.dss.isDraftPost !== NUMBERS.ONE) {
                this.dss.user_community_list.splice(index, 1);
              } else {
                commData['checked'] = this.isSelectedComm(commData?.id);
              }
            });
          }
        } else {
          this.fcs.errorHandeler(data);
        }
      }, () => {
        this.loading_data_in_process = false;
      });
    }));
  }
  /***
   * get Selected User Communities
  */
  isSelectedComm(comm_id): boolean {
    const x = this.dss.posting_data.screen3.selected_community.includes(comm_id);
    if (x == false) {
      return this.dss.posting_data.screen3.selected_community.includes(comm_id.toString());
    } else {
      return true;
    }
  }
  /***
   * add Selected User Communities
  */
  addCommunity(e): boolean {
    this.err_msg = '';
    if (e.target.checked == true) {
      let selected_comm_len = 0;
      for (let i = 0; i < this.dss.posting_data.screen3.selected_community.length; i++) {
        const x = this.dss.user_community_list.find(obj => obj.id == this.dss.posting_data.screen3.selected_community[i] && obj.is_public == 1);
        if (x != undefined) {
          selected_comm_len++;
        }
      }

      if ((this.dss.posting_data.screen3.selected_community.length - selected_comm_len) > 4) {
        this.err_msg = this.mls.languageText.create_post_community.key1;
        e.target.checked = false;
        this.checkSelectedCommunityList.emit({ showColor: this.showColor, errMsg: this.err_msg });
        return false;
      }
      this.dss.posting_data.screen3.selected_community.push(e.target.value);
    } else {
      const index = this.dss.posting_data.screen3.selected_community.indexOf(e.target.value);
      if (index != -1) {
        this.dss.posting_data.screen3.selected_community.splice(index, 1);
      } else {

        // tslint:disable-next-line: radix
        const index2 = this.dss.posting_data.screen3.selected_community.indexOf(parseInt(e.target.value));
        if (index2 != -1) {
          this.dss.posting_data.screen3.selected_community.splice(index2, 1);
        }
      }
    }

    if (this.dss.posting_data.screen3.selected_community.length ||
      this.dss.posting_data.screen3.selected_association.length) {
      this.showColor = true;
    } else {
      this.showColor = false;
    }

    this.checkSelectedCommunityList.emit({ showColor: this.showColor, errMsg: this.err_msg });
  }
  /**
   * Show More Community
  */
  showMoreCommunity(): void {
    /**
      * Show Community which is are selected during post,should be come up on top , pass these parameters in api call
    */
    let additionalParam = {};
    let repostParam = {};
    if (this.dss.posting_data.feed_edit_mode.feed_id) {
      additionalParam = {
        product_type: PRODUCT_TYPE_CONSTANT.FEED,
        product_id: this.dss.posting_data.feed_edit_mode.feed_id
      };
    } else if (this.dss.isRepostStatus === REPOST_STATUS.TWO) {
      repostParam = {
        repost_product_id: this.dss.repostProductId,
        repost_product_type: this.dss.repostProductType
      };
    }
    this.loading_data_in_process = false;
    this.subscriptions.add(this.getSer.getCommunityList(COMMUNITY_LIST_TYPE.MY_ALL_COMMUNITY, this.viewMoreOffset.toString(), additionalParam, repostParam).subscribe(resData => {
      this.loading_data_in_process = false;
      this.viewMoreOffset = resData.data.offset;
      this.jwtSer.decodeData(resData).then(data => {
        if (data.status == NUMBERS.ONE) {
          if (data.code == STATUS_CODE.TWO_THOUSAND) {
            this.dss.user_community_list = this.dss.user_community_list.concat(resData.data.community_list[0]['list']);
            this.view_more_community_flag = resData.data.community_list[0]['flags']['view_more'];
            this.dss.user_community_list.map((commData, index) => {
              if (commData?.id === this.dss.calling_from_community_object['id'] && index) {
                this.dss.user_community_list.splice(index, 1);
              } else {
                commData['checked'] = this.isSelectedComm(commData?.id);
              }
            });
          }
        } else {
          this.fcs.errorHandeler(data);
        }
      }, () => {
        this.loading_data_in_process = false;
      });
    }));
  }

  /**
   * On Destroy
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
